export default "__VITE_ASSET__Cj8i0y90__"